import { Chip } from 'react-native-paper'
import { ContributionType } from '../../../../generated/graphql'
import { createStyle } from '../../../../contexts/global-styles.provider'
import { useTranslation } from 'react-i18next'
import { Contribution } from '../../perspectives/perspective/types'

const CONTRIBUTION_TYPE_LABELS = {
  [ContributionType.Challenge]: 'Challenge',
  [ContributionType.Edit]: 'Edit',
  [ContributionType.Inquiry]: 'Inquiry',
  [ContributionType.Reserved]: 'Reserved',
  [ContributionType.OwnerEdit]: 'Owner Change',
} as const

export const ContributionTypeChip = ({
  contribution,
}: {
  contribution: Contribution
}) => {
  const { t } = useTranslation('contributions')
  const styles = useStyles(contribution)
  return (
    <Chip
      mode={'flat'}
      style={styles.typeChip}
      compact
      textStyle={styles.typeChipLabel}
    >
      {t(CONTRIBUTION_TYPE_LABELS[contribution.contributionType])}
    </Chip>
  )
}

const useStyles = (contribution: { contributionType: ContributionType }) => {
  const hook = createStyle(({ theme }) => {
    const contributionColor =
      theme.colors[
        contribution.contributionType.toLowerCase() as
          | 'challenge'
          | 'edit'
          | 'inquiry'
          | 'reserved'
          | 'owner_edit'
      ]

    return {
      typeChip: {
        borderRadius: 20,
        backgroundColor: contributionColor,
        padding: 0,
      },
      typeChipLabel: {
        color: [ContributionType.Edit, ContributionType.OwnerEdit].includes(
          contribution.contributionType
        )
          ? 'black'
          : 'white',
        fontSize: 12,
        lineHeight: 15,
      },
    }
  })
  return hook()
}
